import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { ScoreReport } from '@digital-platform/rs-circularity/domain';
import { urlConstantsToken } from './url.constants';

@Injectable({
  providedIn: 'root',
})
export class CircularitySurveyService {
  protected urlConstants = inject(urlConstantsToken);

  scoreUrl = this.urlConstants.SURVEY_RESULTS;

  constructor(private httpClient: HttpClient) {}

  public getScoreReport(answerChoices: string[]): Observable<ScoreReport> {
    const url = this.scoreUrl;
    return this.httpClient.post<ScoreReport>(url, answerChoices, {
      headers: this.getHttpHeaders(),
    });
  }

  private getHttpHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
    });
  }
}
